module.exports = __webpack_public_path__ + "static/media/manchester_city_logo.1d5b64ec.png";